const HASH = {
  offers: 'offers',
  informal1to1s: 'informal1to1s',
  conferences: 'conferences',
}

export { HASH }
